// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_6N8","colBig":"styles_colBig__1j5GX","colSmall":"styles_colSmall__GMhWl","shopifyNameWrapper":"styles_shopifyNameWrapper__d-umX"};